import { render, staticRenderFns } from "./CopyStakeJobManagementTab.vue?vue&type=template&id=1bf720aa&scoped=true&lang=pug"
import script from "./CopyStakeJobManagementTab.vue?vue&type=script&lang=ts"
export * from "./CopyStakeJobManagementTab.vue?vue&type=script&lang=ts"
import style0 from "./CopyStakeJobManagementTab.vue?vue&type=style&index=0&id=1bf720aa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf720aa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VCol,VIcon,VRow})
